export const USA = 'US - United States Of America';
export const GrowerOnline = 'GOL';
export const GrowerOnlineWebsiteName = 'GrowerOnline';